module.exports = __webpack_public_path__ + "static/media/best-practices-icon.7d9ef9ea.svg";